import { ReferencedEntry } from 'contentful';
import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { SpeedBumpList } from 'src/api/contentful/contentTypes.shop';
import { SpeedbumpModal } from '../SpeedbumpModal/SpeedbumpModal';

export interface IChoosePartner {
  entry?: ReferencedEntry<SpeedBumpList>;
  children?: never;
}

export const ChoosePartner: React.FC<IChoosePartner> = ({ entry }) => {
  const [ isOpen, setIsOpen ] = useState(true);

  if (isOpen) {
    return <SpeedbumpModal isOpen entry={entry} onRequestClose={() => setIsOpen(false)} />;
  }

  return <Redirect to="/shop" push />;
};
